import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: 40px 20px;
`;

const ErrorCode = styled.h1`
  font-size: 120px;
  font-weight: 700;
  color: #34D399;
  margin-bottom: 16px;
`;

const Title = styled.h2`
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #1f2937;
`;

const Message = styled.p`
  font-size: 18px;
  color: #6b7280;
  margin-bottom: 32px;
`;

const HomeButton = styled(Link)`
  display: inline-block;
  padding: 14px 32px;
  background: #34D399;
  color: white;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s;

  &:hover {
    background: #10b981;
  }
`;

function NotFound() {
  return (
    <Container>
      <ErrorCode>404</ErrorCode>
      <Title>Page Not Found</Title>
      <Message>Sorry, the page you are looking for does not exist.</Message>
      <HomeButton to="/">Go Back Home</HomeButton>
    </Container>
  );
}

export default NotFound;
